import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  external?: boolean;
}
export function CTAButton({
  href,
  children,
  external = false
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className="group inline-flex w-full max-w-[560px] items-center justify-center gap-2 rounded-md border-b-4 border-brandgreendark bg-brandgreen px-6 py-4 text-center font-display text-[19px] uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-10px_rgba(23,163,74,0.85)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#1DBF57] active:translate-y-[2px] sm:px-10 sm:py-5 sm:text-[24px]" data-id="element-30" data-mp="2l099amnvpy2p">
      <span data-id="element-31" data-mp="3cpual1a95qob">{children}</span>
      <ChevronRightIcon className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" strokeWidth={3} data-id="element-32" data-mp="3cp2k24viij4w" />
    </a>;
}